import api from "./api.ts";

const url = process.env.REACT_APP_DB_URI;

export const postBrand = async (brandData: any, accessToken: string) => {
    try {
        const response = await api.post(`${url}/brands/`, brandData);
        return response;
    } catch (err) {
        return err;
    }
}

export const updateBrand = async (id: string, brandData: any, accessToken: string) => {
    try {
        const response = await api.put(`${url}/brands/${id}/`, brandData);
        return response;
    } catch (err) {
        return err;
    }
}

export const getBrands = async (acessToken: string) => {
    try {
        const response = await api.get(`${url}/brands/`);
        return response;
    } catch (err) {
        return err;
    }
}

export const getUserBrands = async (accesstoken: string, id?: any) => {
    try {
        const response = await api.get(`${url}/brands/brands-by-user/?user_id=${id}`);
        return response;
    } catch (err) {
        return err;
    }
}

export const deleteBrand = async (id: string, accessToken: string) => {
    try {
        const response = await api.delete(`${url}/brands/${id}/`);
        return response;
    } catch (err) {
        return err;
    }
}
